import React, { Component } from "react";

import ApartmentDetails from "./apartmentDetails";

export default class apartment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apartments: [
        {
          name: "The Park-Lakeside Apartment",
          furnished: true,
          roomType: null,
          busService: [
            "Campus Bus: RSM (5 mins walk, depends on Building)",
            "Athens Transit: #14 (Comes inside the community, variable walk duration based on buildings)",
          ],
          busFreq: "20 mins",
          distFromTC: "5.4Kms",
          availability: "4BHK/2Bath | 2BHK/1Bath",
          pros: [
            "Rent Includes Water+Internet",
            "You'll find most of the Indian students living here",
            "20 mins walk to University Village(UV) and Indian Grocery store",
          ],
          cons: ["Bus service only till 6 PM and no transit on Weekends", "Pests (If kept uncleaned)"],
        },
        {
          name: "MooseClub Condos",
          furnished: false,
          roomType: null,
          busService: [
            "Campus Bus: UV, Intersession UV during sem breaks, Night campus during nights, Weekenders during weekends (One bus stop for all, 6-7 mins walk)",
            "Athens Transit: #9 (5-6 mins walk), #14(4-5 mins walk)",
          ],
          busFreq: "15- 20 mins for UV, 30 mins for Route 14 and 1 hour for route 9",
          distFromTC: "4.3kms",
          availability: null,
          pros: [
            "3 min Walk to Indian Grocery Store and 6 mins to University Village(UV)",
            "Individual Rooms and Bathrooms",
            "Close to Campus",
          ],
          cons: ["Poor Maintenance", "Rent does not include any utilities"],
        },
        {
          name: "RiverClub Apartments",
          furnished: true,
          roomType: "2BHK/2 Bath | 3BHK/3Bath | 4BHK/2Bath",
          busService: ["Campus Bus : NA", "Athens Transit: #9 (Bus stops on highway, variable walk duration based on buildings)"],
          busFreq: "1 hour",
          distFromTC: "5.9Kms",
          availability: null,
          pros: [
            "Individual Rooms and Bathrooms",
            "Spacious outdoors",
            "Roommate Matching",
            "Rent Includes Water+Internet",
            "Maintenance is done within a day",
          ],
          cons: [
            "Athens Transit is one hour once",
            "Bus service till 6:30 PM on weekdays and no service on weekends",
            "30 mins walk to UV",
          ],
        },
        {
          name: "University Village",
          furnished: false,
          roomType: "1BHK,1 Bath | 2BHK,1Bath",
          busService: [
            "Campus Bus : UV, (Intersession UV during sem breaks, Night campus during nights, Weekenders during weekends) (stops in front of most buildings)",
            "Athens Transit : #14 (Depends on Building: P,Q,R,S has access, 5 mins walk)",
          ],
          busFreq: "15-20 mins",
          distFromTC: "3.8Kms",
          availability: null,
          pros: [
            "On campus bus network, so no worries for commutation",
            "Maintenance is done within a day",
            "Roommate Matching",
            "Rent Includes Water+Internet+Electricity",
            "University Maintained",
            "Leasing available on semester basis",
          ],
          cons: [
            "Too Costly as compared to other places with same features",
            "Rooms are small",
            "Less spacious surroundings (Like College Hostels)",
            "No recreational areas (But University recreational complex is nearby, again depends on building)",
          ],
        },
        {
          name: "Riverbend Apartments",
          furnished: false,
          roomType: "2BHK,1Bath",
          busService: ["Campus Bus : RSM", "Athens Transit : #12"],
          busFreq: "20 mins",
          distFromTC: "4.4Kms",
          availability: null,
          pros: ["spacious rooms"],
          cons: ["Small kitchen and bathroom", "Bus service only till 6 PM and no transit on Weekends"],
        },
        {
          name: "Polo Club Apartments",
          furnished: true,
          roomType: "2BHK/2 Bath | 4BHK/4Bath",
          busService: ["Campus Bus : RSM", "Athens Transit : #25"],
          busFreq: "40 mins - 1 hour",
          distFromTC: "5.8Kms",
          availability: null,
          pros: ["spacious rooms", "Near to Krogers and Walmart"],
          cons: ["Bus service only till 6 PM and no transit on Weekends", "Pests ( If not clean)", "Maintenance is not good"],
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <section>
            <header className="section_head">Popular Apartments in Athen, GA where most Indians Stay</header>
            <hr />
            <p>
              According to all of us, while choosing the residence, along with RENT following things should be considered in order (of
              priority from high to low, may differ from individual perspective).:
            </p>
            <ul>
              <li>Transport. ( If you don't have own vehicle).</li>
              <li>
                Utilities (Electricity, Water, Internet). (Majority has basic House appliances like Refrigerator, Induction Stove + Oven
                Unit, Washer+Dryer)
              </li>
              <li>
                Distance from Campus (Check for your respective campus buildings and nearby stop) * / Grocery stores/ Restaurants(even fast
                food).
              </li>
              <li>Community.</li>
              <li>Furniture (Bed, Mattress, Tables, Chairs, Microwave, Couch, TV, etc.)</li>
              <li>Amenities such as Recreational activities, Surroundings. (Least concerned).</li>
            </ul>
            <b className="text-danger">*You can download the UGA APP which will give you live location of the buses and its bus stops.</b>
            <br />
            Based on Above we give our opinion for following few apartments where most of Indians are currently staying.
            <br />
            <br />
          </section>
          <section>
            <header className="section_head">Apartment List</header>
            <hr />
            {this.state.apartments.map((apt, index) => {
              return (
                <React.Fragment key={"apartment" + index}>
                  <ApartmentDetails apartment={apt} />
                  <br />
                </React.Fragment>
              );
            })}
          </section>
        </div>
      </React.Fragment>
    );
  }
}
